import HorizontalList from '../classes/HorizontalList';
import TrackBar from '../classes/TrackBar';

(function() {
	const posts = Array.from( document.querySelectorAll('.posts-row-overflow') );
	
	const _createTrack = () => {
		const scrollTrack = document.createElement('div');
		scrollTrack.classList.add('ui-scroll-state--track');
		scrollTrack.style.width = '50%';
		
		const scrollElement = document.createElement('div');
		scrollElement.classList.add('ui-scroll-state');
		
		scrollElement.appendChild(scrollTrack);
		
		return scrollElement;
	};
	
	
	posts.forEach(postsItems => {
		const items = postsItems.querySelector('.posts-collection--scrollable');
		const effectEl = items.querySelector('.posts-collection--items');
		
		const horizontalList = new HorizontalList(postsItems, items, effectEl, '.posts-collection--item');
		
		const track = _createTrack();
		items.appendChild(track);
		
		const trackBar = new TrackBar(track, postsItems);
		horizontalList.attachTrack(trackBar);
	});
})();